export {
  default as instructor,
  ReactComponent as Instructor,
} from '@assets/icons/features-and-amenities/instructor.svg'    
